const axiosBase = require('axios');

const axios = axiosBase.create();
axios.defaults.headers.common['X-REQUESTED-WITH'] = 'XMLHttpRequest';

module.exports = axios;
